import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './new-footer.component.html',
  styleUrls: ['./new-footer.component.scss']
})
export class NewFooterComponent implements OnInit{
  @Output() changeCourse = new EventEmitter<string>()
  @Output() changeNav = new EventEmitter<string>()

    @Output() change1 = new EventEmitter<string>()
  
  
  @Input('pageType') pageType:any;
  
    @Input('hideBarFlag') hideBarFlag!: boolean;
  
    @Output() change = new EventEmitter<string>()
   menuItemsList: any = {
    'cat': {
      courses: [
        { name: 'CAT 2025 Course', link: '/cat-2025', linktext: '', img: '' },
        { name: 'CAT 2026 Course', link: '/cat-2026', linktext: '', img: '' },
        { name: 'CAT 2027 Course', link: '/cat-2027', linktext: '', img: '' },
        { name: 'CAT Mock Test', link: '/cat-mock-test', linktext: '', img: '' },
        { name: 'Best CAT Books', link: '/best-cat-books', linktext: '', img: '' },
         { name: 'CAT Study Material', link: '/free-cat-study-material', linktext: '', img: '' },
        { name: 'IIM ABC', link: '/iim-abc', linktext: '', img: '' },
        { name: 'CAT Previous Paper', link: '/test/cat-previous-papers', linktext: '', img: '' },
        { name: 'Best CAT Books', link: '/best-cat-books', linktext: '', img: '' },
      ]
    },

    'mba': {
      courses: [
        { name: 'XAT Course', link: '/xat-coaching', linktext: '', img: '' },
        { name: 'SNAP Course', link: '/snap-online-coaching', linktext: '', img: '' },
        { name: 'NMAT Course', link: '/nmat-online-coaching', linktext: '', img: '' },
        { name: 'XAT Previous Paper', link: '/test/xat-previous-papers', linktext: '', img: '' },
        { name: 'SNAP Previous Paper', link: '/test/snap-previous-papers', linktext: '', img: '' },
        { name: 'GMAT Online Course', link: '/gmat', linktext: '', img: '' },
        { name: 'CMAT Course', link: '/details/cmat-course', linktext: '', img: '' },

      ],
     
    },

    'ipmat': {
      courses: [
        { name: 'IPMAT Online Course', link: '/ipmat', linktext: '', img: '' },
        { name: 'IPMAT Mock Test', link: '/ipmat-mock-test', linktext: '', img: '' },
        { name: 'Best IPMAT Books', link: '/best-ipmat-books', linktext: '', img: '' },
        { name: 'IPMAT Previous Paper', link: '/test/ipmat-previous-papers', linktext: '', img: '' },
        { name: 'IPMAT Study Material', link: '/free-ipmat-study-material', linktext: '', img: '' },
         { name: 'CUET Course', link: '/cuet', linktext: '', img: '' },
        { name: 'CUET Previous Paper', link: '/test/cuet-previous-papers', linktext: '', img: '' },
        { name: 'CUET Mock Test', link: '/cuet-mock-test', linktext: '', img: '' },
      ],
     
    },

    'clat': {
      courses: [
        { name: 'CLAT 2026 Course', link: '/clat-coaching', linktext: '', img: '' },
        { name: 'CLAT Mock Test', link: '/clat-mock-test', linktext: '', img: '' },
        { name: 'Best CLAT Books', link: '/best-clat-books', linktext: '', img: '' },
        { name: 'CLAT Previous Paper', link: '/test/clat-previous-papers', linktext: '', img: '' },
        { name: 'CLAT Study Material', link: '/free-clat-study-material', linktext: '', img: '' },
      ],
     
    },

    'neet': {
      courses: [
        { name: 'NEET 2026 Course', link: '/neet-coaching', linktext: '', img: '' },
        { name: 'NEET Mock Test ', link: '/neet-mock-test', linktext: '', img: '' },
        { name: 'NEET Study Material', link: '/neet-study-material', linktext: '', img: '' }
      ]
    },

    'iit':{
      courses: [
        { name: 'JEE 2026 Course', link: '/iit-jee-coaching', linktext: '', img: '' },
        { name: 'JEE Crash Course', link: '/jee-crash-course', linktext: '', img: '' },
        { name: 'JEE Mock Test', link: '/jee-mock-test', linktext: '', img: '' },
       { name: 'Bitsat Crash Course', link: '/bitsat-crash-course', linktext: '', img: '' },
        { name: 'JEE Study Material', link: '/jee-study-material', linktext: '', img: '' },
      ],
    
    }

  }

  constructor(public router: Router){

  }

  notificationList:any[]=[]
  gotoBlog(val: any) {
    window.open(val, '_blank')
  }

  gotoProduct(val: any) {
    if (val) {
      this.changeCourse.emit(val)
    }
  }

  ngOnInit(): void {
    
  }

  gotoLink(val:any){

  }

  download2(){
    
  }

  gotoFooter(val:any){

  }

  scrollTo1(val: any) {
    // this.courseService.saveScroll(val)
    // this.router.navigate(['/mba'])

  }

  qa(val: any) {
    this.change.emit(val)
    // this.router.navigate(['/test/' + val])
  }

  megMenuJs() {

    const menu: any = document.querySelector(".menu");
    const menuMain = menu.querySelector(".menu-main");
    const goBack = menu.querySelector(".go-back");
    const menuTrigger: any = document.querySelector(".mobile-menu-trigger");
    const closeMenu = menu.querySelector(".mobile-menu-close");
    let subMenu: any;
    menuMain.addEventListener("click", (e:any) => {
      if (!menu.classList.contains("active")) {
        return;
      }
      if (e.target.closest(".menu-item-has-children")) {
        const hasChildren = e.target.closest(".menu-item-has-children");
        showSubMenu(hasChildren);
      }
    });
    goBack.addEventListener("click", () => {
      hideSubMenu();
    })
    menuTrigger.addEventListener("click", () => {
      toggleMenu();
    })
    closeMenu.addEventListener("click", () => {
      toggleMenu();
    })
    let menuOverlay: any = document.querySelector(".menu-overlay")
    menuOverlay.addEventListener("click", () => {
      toggleMenu();
    })
    function toggleMenu() {
      menu.classList.toggle("active");
      menuOverlay.classList.toggle("active");
    }
    function showSubMenu(hasChildren:any) {
      subMenu = hasChildren.querySelector(".sub-menu");
      subMenu.classList.add("active");
      subMenu.style.animation = "slideLeft 0.5s ease forwards";
      const menuTitle = hasChildren.querySelector("i").parentNode.childNodes[0].textContent;
      menu.querySelector(".current-menu-title").innerHTML = menuTitle;
      menu.querySelector(".mobile-menu-head").classList.add("active");
    }

    function hideSubMenu() {
      subMenu.style.animation = "slideRight 0.5s ease forwards";
      setTimeout(() => {
        subMenu.classList.remove("active");
      }, 300);
      menu.querySelector(".current-menu-title").innerHTML = "";
      menu.querySelector(".mobile-menu-head").classList.remove("active");
    }

    window.onresize = function () {
      // if (this.innerWidth > 991) {
      //   if (menu.classList.contains("active")) {
      //     toggleMenu();
      //   }

      // }
    }


  }

  openMocks(){
    this.changeNav.emit('mocks')
  }

  ngAfterViewInit(){
  }

}
